<template>
  <div class="medical-analyses-report">
    <div class="layout documents-report">
      <div class="layout-header">
        <div class="layout-title">Отчёт по анализам сотрудников</div>
        <div class="layout-header-actions">
          <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div>

          <div class="layout-header-action">
            <export-google-forms-action ref="googleForm" table-name="medical_analyses" />
          </div>
        </div>
      </div>

      <medical-analyses-report-filters ref="filters" @inited="onFiltersInit" @apply="applyFilters" />

      <medical-analyses-report-table
        ref="table"
        :inited="inited"
        :loading="loading"
        :workers="workers"
        :filters="filtersChangesTableRows"
        @nextPage="nextPage"
      />
    </div>

    <to-top-button element=".layout" />
  </div>
</template>

<script>
import MedicalAnalysesReportFilters from "./components/medical-analyses-report-filters";
import MedicalAnalysesReportTable from "./components/medical-analyses-report-table";
import ExportGoogleFormsAction from "./components/export-google-forms-action";
import ToTopButton from "@/components/to-top-button";
import Button from "@/components/controls2/Button";
import { WorkerMedicalAnalyses } from "../../../entities/models/worker-medical-analyses";

export default {
  name: "medical-analyses-report",
  components: {
    MedicalAnalysesReportFilters,
    MedicalAnalysesReportTable,
    ExportGoogleFormsAction,
    ToTopButton,
    "c-button": Button,
  },
  data() {
    return {
      bookmark: false,
      inited: false,
      page: 1,
      loading: false,
      lastRequestIsEmpty: false,
      workers: [],
      filtersChangesTableRows: [],
    };
  },
  methods: {
    getParams() {
      const filters = this.$refs.filters.getParams();

      return {
        filters,
        page: this.page,
      };
    },
    reformatTableRows({ filters }) {
      const appliedFilters = [];
      const allowedFilters = [
        "expireInDaysFrom",
        "expireInDaysTo",
        "medicalAnalysesTypeIds",
        "medicalAnalysesTypeIdsExcept",
        "medicalAnalysesIds",
        "expirationType",
      ];

      filters.split("&").forEach((item) => {
        const [filterName, value] = item.split("=");
        if (value && allowedFilters.includes(filterName)) {
          appliedFilters.push({
            name: filterName,
            values: value.split(","),
          });
        }
      });

      this.filtersChangesTableRows = appliedFilters;
    },
    loadData() {
      if (this.loading) return;
      if (this.lastRequestIsEmpty) return;

      this.loading = true;
      const params = this.getParams();

      this.reformatTableRows(params);
      this.$refs.googleForm.update(params.filters);

      this.$store.dispatch("medicalAnalysesReport/loadAnalyses", params).then((res) => {
        const workers = res.map((doc) => new WorkerMedicalAnalyses(doc));
        if (!workers.length) this.lastRequestIsEmpty = true;
        this.workers = [...this.workers, ...workers];
        this.loading = false;
        this.inited = true;
      });
    },

    onFiltersInit() {
      this.loadData();
    },

    applyFilters() {
      this.workers = [];
      this.loading = false;
      this.page = 1;
      this.lastRequestIsEmpty = false;
      this.loadData();
    },

    nextPage() {
      if (!this.inited) return;
      if (this.loading) return;
      this.page += 1;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.layout-header {
  align-items: center;
}

@include mobileAndTablet {
  .documents-report {
    padding-bottom: 84px;
  }
}

@include onlyStandartMobile {
  .documents-report {
    padding-bottom: 20px;
  }
  .documents-report-table {
    margin-left: -21px;
    margin-right: -21px;
    margin-top: 10px;
    padding-bottom: 12px;
  }
  .layout-header {
    margin-bottom: 24px;
    height: auto;
  }

  @include onlyMobile {
    .layout-header {
      align-items: center;
    }
  }
}
</style>
